export const currencySymbols = {
  Percentage: '%',
  USD: '$',
  EUR: '€',
  INR: '₹',
  GBP: '£'
}

export const getCurrencySymbol = (currencyCode) => {
  return currencySymbols[currencyCode] || null // Returns null if the code is not found
}
